export const BackArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0004 11H7.83041L12.7104 6.12004C13.1004 5.73004 13.1004 5.09004 12.7104 4.70004C12.6179 4.60733 12.508 4.53379 12.387 4.4836C12.2661 4.43342 12.1364 4.40759 12.0054 4.40759C11.8744 4.40759 11.7448 4.43342 11.6238 4.4836C11.5028 4.53379 11.3929 4.60733 11.3004 4.70004L4.71041 11.29C4.61771 11.3826 4.54416 11.4924 4.49398 11.6134C4.4438 11.7344 4.41797 11.8641 4.41797 11.995C4.41797 12.126 4.4438 12.2557 4.49398 12.3767C4.54416 12.4976 4.61771 12.6075 4.71041 12.7L11.3004 19.29C11.393 19.3826 11.5029 19.4561 11.6239 19.5062C11.7448 19.5563 11.8745 19.5821 12.0054 19.5821C12.1363 19.5821 12.266 19.5563 12.387 19.5062C12.5079 19.4561 12.6178 19.3826 12.7104 19.29C12.803 19.1975 12.8764 19.0875 12.9265 18.9666C12.9766 18.8456 13.0024 18.716 13.0024 18.585C13.0024 18.4541 12.9766 18.3245 12.9265 18.2035C12.8764 18.0825 12.803 17.9726 12.7104 17.88L7.83041 13H19.0004C19.5504 13 20.0004 12.55 20.0004 12C20.0004 11.45 19.5504 11 19.0004 11Z"
        fill="white"
      />
    </svg>
  );
};

export default BackArrowIcon;
